import { createFileRoute } from '@tanstack/react-router';
import { UpdatePasswordForm } from '@onesource/components';

export const Route = createFileRoute('/auth/update-password')({
  component: UpdatePassword,
});

function UpdatePassword() {
  return <UpdatePasswordForm redirectTo="/auth/login" minPasswordLength={8} />;
}
